/**
 * ⭐ EL PRECIO DE WAYO PREMIUM, EN UN SOLO SITIO.
 *
 * Cambia los dos números de abajo y cambia TODA la web de una vez: la página de
 * premium y sus datos estructurados, el JSON-LD de la home, la FAQ, la
 * calculadora, las landings, la barra de oferta y lo que se manda a Google
 * Analytics. Antes estaba escrito a mano en 36 sitios repartidos en 22 ficheros.
 *
 * Lo leen tanto React como los scripts de build (`generate-sitemap.js` y
 * `prerender-meta.js`), que son Node en modo ESM, por eso NO puede ser un .json:
 * con `"type": "module"` Node exige un atributo de importación para JSON.
 *
 * ⚠️ CAMBIAR ESTO NO CAMBIA LO QUE COBRA STRIPE. El cobro lo decide
 * `STRIPE_ANNUAL_PRICE_ID` en el .env del servidor:
 *   29,99 → price_1UCMTrL01kyodbuzXrH5Enob
 *   49,99 → price_1Tki3tL01kyodbuzmovUSmWx
 * Si tocas uno, toca el otro. (Y en las tiendas se cambia a mano en la consola.)
 */

/** Lo que se cobra hoy por el plan anual. 1-oct-2026: vuelve a 49,99 al acabar la oferta. */
export const PRECIO_ANUAL_NUM = 49.99;
/** El precio de antes: el que va tachado en la oferta. */
export const PRECIO_ANTERIOR_NUM = 49.99;
export const MONEDA = "EUR";
export const SIMBOLO = "€";
export const DIAS_PRUEBA = 7;

const es = (n) => n.toFixed(2).replace(".", ",");

/** "29.99" — formato de schema.org: punto decimal y sin símbolo. */
export const PRECIO_ANUAL_ISO = PRECIO_ANUAL_NUM.toFixed(2);
/** "29,99 €" — para enseñar en pantalla. */
export const PRECIO_ANUAL = `${es(PRECIO_ANUAL_NUM)} ${SIMBOLO}`;
/** "2,50 €" — el equivalente mensual. */
export const PRECIO_MENSUAL_EQUIV = `${es(PRECIO_ANUAL_NUM / 12)} ${SIMBOLO}`;
/** "49,99 €" — el tachado. */
export const PRECIO_ANTERIOR = `${es(PRECIO_ANTERIOR_NUM)} ${SIMBOLO}`;
